export default function DischargeCalendarIcon({
  width = 14,
  height = 14,
  color = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M5.25 6.125H3.5V7.875H5.25V6.125Z' fill='currentColor' />
      <path d='M7.875 6.125H6.125V7.875H7.875V6.125Z' fill='currentColor' />
      <path d='M5.25 8.75H3.5V10.5H5.25V8.75Z' fill='currentColor' />
      <path d='M7.875 8.75H6.125V10.5H7.875V8.75Z' fill='currentColor' />
      <path d='M10.5 6.125H8.75V7.875H10.5V6.125Z' fill='currentColor' />
      <path d='M10.5 8.75H8.75V10.5H10.5V8.75Z' fill='currentColor' />
      <path
        d='M13.125 2.625H11.375V0.875C11.375 0.642936 11.2828 0.420376 11.1187 0.256282C10.9546 0.0921872 10.7321 0 10.5 0C10.2679 0 10.0454 0.0921872 9.88128 0.256282C9.71719 0.420376 9.625 0.642936 9.625 0.875V2.625H4.375V0.875C4.375 0.642936 4.28281 0.420376 4.11872 0.256282C3.95462 0.0921872 3.73206 0 3.5 0C3.26794 0 3.04538 0.0921872 2.88128 0.256282C2.71719 0.420376 2.625 0.642936 2.625 0.875V2.625H0.875C0.642936 2.625 0.420376 2.71719 0.256282 2.88128C0.0921872 3.04538 0 3.26794 0 3.5V13.125C0 13.3571 0.0921872 13.5796 0.256282 13.7437C0.420376 13.9078 0.642936 14 0.875 14H13.125C13.3571 14 13.5796 13.9078 13.7437 13.7437C13.9078 13.5796 14 13.3571 14 13.125V3.5C14 3.26794 13.9078 3.04538 13.7437 2.88128C13.5796 2.71719 13.3571 2.625 13.125 2.625ZM12.25 12.25H1.75V4.375H12.25V12.25Z'
        fill={color}
      />
    </svg>
  );
}
